import { IPackageListingAppText, defaultText } from '../../custom/classes/package-listing-text';
import { ActionType, IPackageListingStateAction } from '../../classes/package-listing-actions';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function packageTextReducer(state: IPackageListingAppText = defaultText, action: IPackageListingStateAction) {
    switch (action.type) {
        case ActionType.UpdateSettings: {
            return { ...state, ...action.value, requesting: false, apiError: null } as IPackageListingAppText;
        }
        default:
            return state;
    }
}
